<template>
  <div class="list">
    <header class="list-header">
      <section
        class="list-header-heading"
        v-if="heading || description"
      >
        <h1 class="heading">
          {{ heading }}
        </h1>
      </section>
      <slot name="page-link" />
    </header>
    <section class="list__controls">
      <slot name="action" />
    </section>
    <slot name="sort" />
    <p
      v-if="description"
      class="list-header-desc copy"
    >
      {{ description }}
    </p>
    <div
      v-if="isLoading"
      :class="grid ? 'grid__list' : ''"
    >
      <component
        :is="placeholders.component"
        v-for="i in placeholders.count"
        :key="i"
      />
    </div>
    <div
      v-else
      :class="grid ? 'grid__list' : ''"
    >
      <template v-for="item in items">
        <slot
          name="item"
          :item="item"
        />
      </template>
    </div>
    <InfoBox
      v-if="isEmpty && !isLoading"
      :is-outlined="true"
      :content="$t(empty)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InfoBox from "./InfoBox";

export default {
  name: "List",
  components: { InfoBox },
  props: {
    heading: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    empty: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    placeholders: {
      type: Object,
      default: null,
    },
    grid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["isLoading"]),
    isEmpty() {
      return !this.items?.length;
    },
  },
};
</script>
